import React from 'react'
import Separator from '../../../../components/helpers/Separator'
import Gallery from '../../../../components/pdf/Gallery'
import LabelValue from '../../../../components/pdf/LabelValue'
import { FlexCol } from '../../../../components/structure/FlexGrid'
import { useTranslation } from 'react-i18next'

const Documents = ({ serviceOrder }) => {
  const { t } = useTranslation('serviceOrders')
  const { documents = [] } = serviceOrder || {}

  if (!documents || !documents?.length) return false

  return (
    <FlexCol width="100%">
      <LabelValue label={t('show.documents')}>
        <Separator weight={1} />
        <Gallery items={documents} thumbHeight="7rem" />
      </LabelValue>
    </FlexCol>
  )
}

export default Documents
